import React from 'react'
import Hero from '../components/Hero';
import AboutUs from '../components/AboutUs';
import WhyChooseUs from '../components/WhyChooseUs';
import OurService from '../components/OurService';
import OurProject from '../components/OurProject';
import OurSkills from '../components/OurSkills';
import HowWeWork from '../components/HowWeWork';
import IntroVideo from '../components/IntroVideo';
import { Helmet } from 'react-helmet-async';

const Home = () => {
  return (
    <>

<Helmet>
  {/* SEO Title */}
  <title>
    Interior Designer in Nagpur for Modern Home Designs | ERA Interio
  </title>

  {/* Meta Description */}
  <meta
    name="description"
    content="Transform Your Dream Home with a Top Interior Designer in Nagpur. Discover Stylish Interiors, Elegant Designs & Smart Spaces!"
  />

  {/* Primary and Secondary Keywords */}
  <meta
    name="keywords"
    content="Interior Designer in Nagpur, Home Decorator, Interior Design Services in Nagpur, Interior Design Company, Living Room Decor Ideas, Bedroom Design"
  />

  {/* Robots */}
  <meta
    name="robots"
    content="index, follow, max-image-preview:large"
  />

  {/* Canonical */}
  <link
    rel="canonical"
    href="https://www.erainterio.com/"
  />

  {/* Open Graph */}
  <meta
    property="og:title"
    content="Interior Designer in Nagpur – Transform Your Space Into a Dream Home"
  />

  <meta
    property="og:description"
    content="Nagpur’s interior designer for homes and apartments. Get creative living room decor ideas, modern bedroom design and end-to-end interior design services. Get your free quote today."
  />

  <meta
    property="og:type"
    content="website"
  />

  <meta
    property="og:url"
    content="https://www.erainterio.com/"
  />

  <meta
    property="og:image"
    content="https://www.erainterio.com/static/media/about-img-1.46bf87808fc6f30b56af.jpg"
  />

  <meta
    property="og:site_name"
    content="ERA Interio"
  />

  {/* Twitter */}
  <meta
    name="twitter:card"
    content="summary_large_image"
  />

  <meta
    name="twitter:title"
    content="Interior Designer in Nagpur – Transform Your Space Into a Dream Home"
  />

  <meta
    name="twitter:description"
    content="Nagpur’s interior designer for homes and apartments. Get creative living room decor ideas, modern bedroom design and end-to-end interior design services. Get your free quote today."
  />

  <meta
    name="twitter:image"
    content="https://www.erainterio.com/static/media/about-img-1.46bf87808fc6f30b56af.jpg"
  />

  {/* Local Business Schema */}
  <script type="application/ld+json">
    {JSON.stringify({
      "@context": "https://schema.org",
      "@type": "ProfessionalService",
      "name": "Interior Designer in Nagpur | ERA Interio",
      "image":
        "https://www.erainterio.com/static/media/eraintrerio-01.619cace3e540999f3bf5.png",
      "@id": "https://www.erainterio.com/#localbusiness",
      "url": "https://www.erainterio.com/",
      "telephone": "+91-8830219839",
      "address": {
        "@type": "PostalAddress",
        "streetAddress":
          "Shop No.2, 1st Floor, Shyama Apartment, Pratap Nagar Square, Pratap Nagar",
        "addressLocality": "Nagpur",
        "addressRegion": "Maharashtra",
        "postalCode": "440022",
        "addressCountry": "IN"
      },
      "openingHoursSpecification": [
        {
          "@type": "OpeningHoursSpecification",
          "dayOfWeek": [
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday",
            "Sunday"
          ],
          "opens": "10:00",
          "closes": "19:00"
        }
      ],
      "sameAs": [
        "https://www.instagram.com/erainterio9/",
        "http://www.facebook.com/erainterior9",
        "https://www.youtube.com/@eraintero"
      ]
    })}
  </script>
</Helmet>

      <Hero />
      <AboutUs />
      <WhyChooseUs/>
      <OurService />
      <IntroVideo />
      <OurProject />
      <HowWeWork />
      <OurSkills />
      {/* <Testimonials /> */}
    </>

  )
}

export default Home
